<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.products' | transloco }}
    </h3>
    <span></span>
    <hx-date-range-select [onlyPastDates]="true" class="date-align" [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>
            <div class="filter">
              <hx-user-select [disabled]="!params.storeId" [(ngModel)]="params.userId" [storeId]="params.storeId" (selectChange)="onUserChanged($event)"></hx-user-select>
            </div>
            <div class="filter">
              <hx-product-category-select [(ngModel)]="params.categoryId" [brandId]="1" (selectChange)="onCategoryChanged($event)"></hx-product-category-select>
            </div>
          </div>
          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 block-table-scroll">
            <table class="m-datatable__table" *ngIf="sales.length && !isloading.sales">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.category' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.product' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.store' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.employee' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.amount' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.discount' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.coins' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.average-price' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of sales"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  {{ item.categoryTitle | uiLabel }}
                </td>

                <td class="m-datatable__cell">
                  <a *ngIf="item.productTitle" [title]="item.productTitle | uiLabel" [routerLink]="['../product-sales/products']" [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, productInfoId: item.productInfoId, productTitle: item.productTitle | uiLabel }">
                    {{ item.productTitle | uiLabel }}
                  </a>
                </td>

                <td class="m-datatable__cell">
                  {{ item.storeTitle | uiLabel }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.paymentUserLastname ?? '' + ' ' + item.paymentUserFirstname ?? '' }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.amountTotal }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.discountSum | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.productTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ (item.productTotal - item.costPriceTotal) | fixed:2 | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.coinSum | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.productTotal / item.amountTotal | fixed:2 | moneyFormat | uiCurrency: item.currency }}
                </td>

              </tr>
              </tbody>
            </table>

            <hx-loader [length]="sales.length" [isLoading]="isloading.sales"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
